import Layout from "../include/layout";
import { Button, Form, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import Filarial from "../include/filarial";
import Joi from "joi-browser";
import CustomAddModal from "../../components/CustomAddModal";
import CustomEditModal from "../../components/CustomEditModal";
import StatutsService from "../statuts/StatutsService";
import SexesService from "./SexesService";


export default function SexeIndex() {
    const activeLink = "SEXES"

    const token = useSelector(state => state.auth.token)
    const [sexes, setSexes] = useState([])
    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)
    const [statuts, setStatuts] = useState([])

    const [errors, setErrors] = useState({});

    const [isVisible, setIsVisible] = useState(false);
    const [editModal, setEditModal] = useState(false);

    const [addFormData, setAddFormData] = useState({
        libelleSexe: '',
        descriptionSexe: '',
    });

    //declaration des variables pour le form d'edition
    const [editFormData, setEditFormData] = useState({
        libelleSexe: '',
        descriptionSexe: '',
        id: ''
    });

    //####GESTION DES REGLES DE VALIDATIONS ###########///
    const schemaAddData = {
        libelleSexe: Joi.string().min(2).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("Libelle"),

        descriptionSexe: Joi.string().min(0).max(1000).empty('').options({
            language: {
                string: { max: "maximum 1000" },
            },
        }).label("Description")
    };

    //GESTION DES REGLES POUR LES FORMULAIRES D'EDITION
    const schemaEditData = {
        libelleSexe: Joi.string().min(2).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("Libelle"),

        descriptionSexe: Joi.string().min(0).max(1000).empty('').options({
            language: {
                string: { max: "maximum 1000" },
            },
        }).label("Description"),

        statutId: Joi.number().required("").empty('').options({
            language: {
              any: { required: 'le champ est obligatoire' },
            },
          }).label("Statut"),

        id: Joi.number().min(1).empty('').options({
            language: {
                string: { min: "minimum 1" },
            },
        }).label("Id")
    };

    //####END GESTION DES REGLES DE VALIDATIONS ###########///

    //Gérer les changements sur les formulaires d'ajout
    const handleChange = (event) => {
        //console.log(name)
        const { name, value } = event.target;

        setAddFormData({ ...addFormData, [name]: value });

        let errorData = { ...errors };
        const errorMessage = validateProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...addFormData };
        customerData[name] = event.target.value;
        setAddFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaAddData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    //Une fonction pour vider les champs du formulaire
    const clearForm = () => {
        setAddFormData({
            libelleSexe: '',
            descriptionSexe: '',
        });
    };


    //get liste sexes
    const fetchSexes = async () => {
        await SexesService.index(token).then((res) => {
            //console.log(res.data.data)
            setSexes(res.data.data.sexes)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //get liste statuts
    const fetchStatuts = async () => {
        await StatutsService.index(token).then((res) => {
            setStatuts(res.data.data.statuts)
        }).catch(error => {
            console.log(error)
        })
    }
    //redirection sur la page edit sans afficher les id dans l'url
    /* const goToEdit = (param) => {
         navigate(myroutes.sexes_edit, { state: { id: param } })
     }*/

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                SexesService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchSexes()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }

    //Gérer les changements sur les formulaires de modification
    const handleEditChange = (event) => {
        const { name, value } = event.target;
        setEditFormData({ ...editFormData, [name]: value });
        //console.log(editFormData)
        let errorData = { ...errors };
        const errorMessage = validateEditProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...editFormData };
        customerData[name] = event.target.value;
        setEditFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateEditProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaEditData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    //Enregistrer un nouveau sexe
    const handleStore = async (event) => {
        event.preventDefault()
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(addFormData,
            schemaAddData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {
            //
            await SexesService.store(addFormData, token).then(response => {
                //Fermer le modal
                setIsVisible(false)
                //Vider les champs du formulaire
                clearForm()
                if (response.data.status === 200) {

                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        timer: 3000,
                    });
                    //Mettre à jour la liste des sexes
                    fetchSexes()
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000,
                    });

                }
            }).catch(error => {
                setIsVisible(false)
                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
                console.log(error);
            })
        }
    }

    ///Content du modal d'ajout de genre
    const addModalContent = (
        <Form className="needs-validation" noValidate onSubmit={handleStore}>
            <div className="col-md-12 mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-name"
                >
                    Libelle <i className="text-danger">*</i>
                </Form.Label>
                <Form.Control
                    className="form-control"
                    id="bs-validation-libelleSexe"
                    type="text"
                    value={addFormData.libelleSexe}
                    onChange={handleChange}
                    placeholder="Exemple : MASCULIN"
                    required={true}
                    name="libelleSexe"
                />

                {errors.libelleSexe && (
                    <div className="alert alert-danger">
                        {errors.libelleSexe}
                    </div>
                )}
            </div>

            <div className="col-md-12 mb-2">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-descriptionSexe" >
                    Description <i className="text-danger"></i>
                </Form.Label>
                <textarea
                    className="form-control"
                    id="bs-validation-descriptionSexe"
                    onChange={handleChange}
                    name="descriptionSexe"
                    rows="3"
                    value={addFormData.descriptionSexe}
                ></textarea>

                {errors.descriptionSexe && (
                    <div className="alert alert-danger">
                        {errors.descriptionSexe}
                    </div>
                )}
            </div>
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setIsVisible(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );

    ///Lancer le modal d'edition
    const lauchEdit = async (id) => {
        await SexesService.show(id, token).then((response) => {
            const data = response.data.data;
            console.log(response.data.data)
            setEditFormData({
                libelleSexe: data.libelleSexe,
                descriptionSexe: data.descriptionSexe,
                id: id
            })
            setEditModal(true)

        }).catch((error) => {
            Swal.fire({
                icon: "error",
                text: error.message,
            });
        });
    }

    //Modification d'un sexe
    const handleUpdate = async (event) => {
        event.preventDefault()
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(editFormData,
            schemaEditData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {

            //
            await SexesService.update(editFormData, token).then(response => {

                //Fermer le modal
                setEditModal(false)
                if (response.data.status === 200) {

                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        timer: 3000,
                    });
                    //Mettre à jour la liste des sexes
                    fetchSexes()
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000,
                    });

                }
            }).catch(error => {
                //Fermer le modal
                setEditModal(false)
                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
                console.log(error);
            })
        }
    }

    ///Content du modal d'edition de sexe
    const editModalContent = (
        <Form className="needs-validation" noValidate onSubmit={handleUpdate}>
            <div className="row">
                <div className="col-md-6">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Libelle <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-libelleSexe"
                        type="text"
                        value={editFormData.libelleSexe}
                        onChange={handleEditChange}
                        placeholder="Exemple : MASCULIN"
                        required={true}
                        name="libelleSexe"
                        style={{ "textTransform": "uppercase" }}
                    />

                    {errors.libelleSexe && (
                        <div className="alert alert-danger">
                            {errors.libelleSexe}
                        </div>
                    )}
                </div>
                <div className=" col-md-6 mb-3">
                    <Form.Label
                        className="form-label fw-bold"
                        htmlFor="bs-validation-name"
                    >
                        Statuts <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Select className="select2 form-select form-select-md" name="statutId" id="bs-validation-statutId" value={editFormData.statutId} onChange={handleEditChange} required>
                        <option value="" disabled selected>Sélectionnez une valeur</option>
                        {statuts.length > 0 && statuts.map(item => (
                            <option key={item.id} value={item.id}>{item.libelleStatut}</option>
                        ))}
                    </Form.Select>

                    {errors.statutId && (
                        <div className="alert alert-danger">
                            {errors.statutId}
                        </div>
                    )}

                </div>
            </div>

            <div className="row mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-descriptionSexe" >
                    Description <i className="text-danger"></i>
                </Form.Label>
                <textarea
                    className="form-control"
                    id="bs-validation-descriptionSexe"
                    onChange={handleEditChange}
                    name="descriptionSexe"
                    rows="3"
                    value={editFormData.descriptionSexe}
                ></textarea>

                {errors.descriptionSexe && (
                    <div className="alert alert-danger">
                        {errors.descriptionSexe}
                    </div>
                )}

            </div>
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setEditModal(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );


    useEffect(() => {
        fetchSexes();
        fetchStatuts()
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Filarial activeLink={activeLink} />

                {/* Responsive Datatable */}
                <div className="card shadow-lg mb-4 mt-2">
                    <h5 className="card-header">Liste des sexes &nbsp;&nbsp;
                        <Button className="rounded-5" variant="primary" onClick={() => setIsVisible(true)} title="Ajouter">
                            <FontAwesomeIcon icon="fa-solid fa-circle-plus" /> Ajouter un sexe</Button>
                    </h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">#</th>
                                    <th className="cell text-white">Libelle</th>
                                    <th className="cell text-white">Description</th>
                                    <th className="cell text-white">Statuts</th>
                                    <th className="cell text-white">Date modifcation</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sexes.length > 0 && sexes.map((item, index) => (
                                    <tr key={index}>
                                        <td className="cell">{index + 1}</td>
                                        <td className="cell">{item.libelleSexe}
                                        </td>
                                        <td className="cell"><span className="truncate">{item.descriptionSexe}</span></td>
                                        <td className="cell">
                                            <span className={item.statuts?.libelleStatut === "ACTIF" ? 'badge rounded-pill bg-success' : 'badge rounded-pill bg-warning'}>{item.statuts?.libelleStatut}</span>
                                        </td>
                                        <td className="cell">
                                            <span>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</span>
                                        </td>
                                        <td className="cell">
                                            <Button onClick={() => lauchEdit(item.id)}
                                                className="btn btn-sm" severity="warning" style={{ color: "white" }}
                                                title="Modifier"
                                            >
                                                <i className="fas fa-edit"></i>
                                            </Button> &nbsp; &nbsp;
                                            <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)}
                                                title="Supprimer">
                                                <i className="fas fa-trash"></i></Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/*/ Responsive Datatable */}

                {/* Modal Ajout des sexes*/}
                <CustomAddModal
                    modalTitle="Enregistrement Sexe"
                    modalContent={addModalContent}
                    visible={isVisible}
                    close={() => setIsVisible(false)}
                />

                {/**End Modal Ajout des sexes*/}

                {/* Modal Edition des sexes*/}
                <CustomEditModal
                    modalTitle="Modification sexe"
                    modalContent={editModalContent}
                    visible={editModal}
                    close={() => setEditModal(false)}
                />

                {/**End Modal Edition des sexes*/}

            </div>

        </Layout>
    )
}